const AccordionButtonComponent = {
    templateUrl: '/ui/collapsibleLeftNav/accordionButton/accordionButton.tpl.html',
    controller: 'accordionButtonController',
    transclude: true,
    bindings: {
        label: '<',
        subTextLabel: '@',
        value: '<',
        requiredFieldCount: '<',
        onRequiredFieldCountClick: '&?',
        isOpen: '<',
        hasChildren: '<',
        notifyAccordionButtonClick: '&',
        closeOtherAccordionsOnOpen: '<',
        isActive: '<',
        isDisabled: '<',
        disableChevron: '<',
        customIcon: '<?',
        notifyCustomIconClick: '&',
        showCustomButton: '<',
        customButtonLabel: '<',
        notifyCustomButtonClick: '&',
        disableUserInteraction: '<'
    }
};

angular.module('umCore')
    .component('uiAccordionButton', AccordionButtonComponent);
